module.exports = __webpack_public_path__ + "img/usersbg.e6690c50.png";